// IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5): вкладка «Display» формы вида ⚙ грида закрывала сам грид (на столе окно формы x 362–1585 px,
// метки теплокарты под ним) — отклик опции не был виден. Пока открыта вкладка Display, окно формы (widget-row, dock 'popout' — свободное окно без
// затемнения фона) встаёт узкой полосой у правого края страницы на всю её высоту; грид слева остаётся видимым и кликабельным. Уход с вкладки
// (другая вкладка, закрытие формы) возвращает прежний рект окна — если пользователь за это время окно не двигал и не тянул; передвинул —
// его положение остаётся (штатное перетаскивание / ресайз окна работают и в полосе). Только стиль окна в этом браузере: на сервер ничего не пишется,
// _widgetRowRects не трогается. Выключатель fe.ux.displayTabDock (дефолт ВКЛ; false — окно формы не двигается, как до правки).

export const DISPLAY_DOCK_FLAG = 'fe.ux.displayTabDock'
export const DISPLAY_DOCK_WIDTH = 340   // px: целевая ширина полосы; меньше минимума окна (store.minWidgetWidth — 20 % страницы) checkPopout не даст

// состояние полосы по id окна формы: { prev — рект до полосы, set — рект полосы после checkPopout } (не на WIDGET: объект виджета не засоряем)
const _docked = new Map()

export function displayDock_on(setting) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5)
    try { return typeof setting === 'function' ? setting(DISPLAY_DOCK_FLAG, true) !== false : true } catch (e) { return true }
}

// рект полосы в координатах страницы (ps = store.getPAGE_size): правый край страницы, вся высота; ширина — max(DISPLAY_DOCK_WIDTH, minW), не шире страницы
export function displayDock_rect(ps, minW = 0) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5)
    if (!ps || !Number.isFinite(ps.page_width) || ps.page_width <= 0 || !Number.isFinite(ps.page_height) || ps.page_height <= 0) return null
    const w = Math.round(Math.min(ps.page_width, Math.max(DISPLAY_DOCK_WIDTH, Number(minW) || 0)))
    return { top: ps.page_top + 'px', left: (ps.page_right - w) + 'px', width: w + 'px', height: ps.page_height + 'px' }
}

const _rectOf = (el) => ({ top: el.style.top, left: el.style.left, width: el.style.width, height: el.style.height })
const _sameRect = (a, b) => !!a && !!b && ['top', 'left', 'width', 'height'].every((k) => String(a[k] || '') === String(b[k] || ''))

export function displayDock_isDocked(W) { return !!W && _docked.has(W.id) }   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5)

// on = true — поставить окно формы W полосой справа; false — вернуть прежний рект. Возвращает true, если стиль окна менялся.
// doc — для юнита (по умолчанию document)
export function displayDock_apply(store, W, on, doc = (typeof document !== 'undefined' ? document : null)) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5)
    if (!store || !W || W.id == null) return false
    const el = doc?.getElementById?.(`WIDGET${W.id}`) || null
    if (!on) {
        const d = _docked.get(W.id)
        if (!d) return false
        _docked.delete(W.id)
        if (!el || W.styleWidget?.dock !== 'popout') return false
        if (!_sameRect(_rectOf(el), d.set)) return false   // окно передвинули / растянули в полосе — положение пользователя остаётся
        store.setWIDGET_style(W, d.prev, false)
        store.checkPopout?.()
        return true
    }
    if (_docked.has(W.id) || !el || W.styleWidget?.dock !== 'popout') return false
    if (W.styleWidget.setWidgetRect) store.checkPopout?.()   // рект открытия ещё не применён — применить, иначе он перебьёт полосу
    const PAGE = store.WORKSPACES?.[W.workspace]?.PAGES?.[W.page]
    const rect = displayDock_rect(store.getPAGE_size?.(PAGE), store.minWidgetWidth)
    if (!rect) return false
    const prev = _rectOf(el)
    if (_sameRect(prev, rect)) return false
    store.setWIDGET_style(W, rect, false)
    store.checkPopout?.()   // clamp окна (минимум 20 % страницы, границы) — полоса запоминается уже после него
    _docked.set(W.id, { prev, set: _rectOf(el) })
    return true
}
